import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import T from '../theme';
import { Btn } from './shared';
import Icon from './Icon';

const F = "'Plus Jakarta Sans', sans-serif";

export default function Navbar() {
 const [scrolled, setScrolled] = useState(false);
 const [menuOpen, setMenuOpen] = useState(false);
 const navigate = useNavigate();

 useEffect(() => {
 const fn = () => setScrolled(window.scrollY > 40);
 window.addEventListener('scroll', fn);
 return () => window.removeEventListener('scroll', fn);
 }, []);

 const links = [
 { label: 'Home', to: '/' },
 { label: 'Services', to: '/services' },
 { label: 'Process', to: '/process' },
 ];

 return (
 <nav style={{
 position: 'fixed', top: 0, left: 0, right: 0, zIndex: 999,
 padding: '0 5%',
 background: scrolled ? 'rgba(244,248,250,0.97)' : 'transparent',
 backdropFilter: scrolled ? 'blur(16px)' : 'none',
 borderBottom: scrolled ? `1px solid ${T.borderGray}` : '1px solid transparent',
 transition: 'all 0.3s ease',
 }}>
 <div style={{
 maxWidth: 1280, margin: '0 auto',
 display: 'flex', alignItems: 'center', justifyContent: 'space-between',
 height: 72,
 }}>
 {/* Logo */}
 <button
 onClick={() => { navigate('/'); setMenuOpen(false); }}
 style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
 >
 <img src="/assets/uxtudio-logo.png" alt="UXtudio" style={{ width: 40,  display: 'block' }} />
 <span style={{ display: 'flex', alignItems: 'baseline' }}>
 <span style={{ fontFamily: F, fontWeight: 800, fontSize: '1.4rem', color: T.navy, letterSpacing: '-0.5px' }}>UX</span>
 <span style={{ fontFamily: F, fontWeight: 400, fontSize: '1.4rem', color: T.aquaDark, letterSpacing: '-0.5px' }}>tudio</span>
 </span>
 </button>

 {/* Desktop links */}
 <div className="desk-links" style={{ display: 'flex', alignItems: 'center', gap: 36 }}>
 {links.map(l => (
 <NavLink
 key={l.to}
 to={l.to}
 end={l.to === '/'}
 style={({ isActive }) => ({
 fontFamily: F,
 fontWeight: isActive ? 700 : 500,
 fontSize: '0.95rem',
 color: isActive ? T.aquaDark : T.inkMid,
 textDecoration: 'none',
 transition: 'color 0.2s',
 borderBottom: isActive ? `2px solid ${T.aqua}` : '2px solid transparent',
 paddingBottom: 2,
 })}
 >
 {l.label}
 </NavLink>
 ))}
 <Btn size="sm" onClick={() => navigate('/contact')}>Free Check-in</Btn>
 </div>

 {/* Mobile hamburger */}
 <button
 className="ham"
 onClick={() => setMenuOpen(!menuOpen)}
 style={{
 display: 'none', background: 'none',
 border: `1.5px solid ${T.borderGray}`, borderRadius: 6,
 padding: '6px 12px', color: T.ink, cursor: 'pointer',
 }}
 >
 <Icon name={menuOpen ? 'close' : 'menu'} size={22} color={T.inkMid} fill={1} />
 </button>
 </div>

 {/* Mobile menu */}
 {menuOpen && (
 <div style={{
 background: T.surface, borderTop: `1px solid ${T.borderGray}`,
 padding: '1.5rem 5%', animation: 'slideDown 0.25s ease',
 boxShadow: '0 8px 24px rgba(11,31,58,0.08)',
 }}>
 {links.map(l => (
 <div key={l.to} style={{ padding: '14px 0', borderBottom: `1px solid ${T.borderGray}` }}>
 <NavLink
 to={l.to}
 end={l.to === '/'}
 onClick={() => setMenuOpen(false)}
 style={({ isActive }) => ({
 fontFamily: F, fontSize: '1.1rem',
 fontWeight: isActive ? 700 : 400,
 color: isActive ? T.aquaDark : T.ink,
 textDecoration: 'none',
 })}
 >
 {l.label}
 </NavLink>
 </div>
 ))}
 <div style={{ paddingTop: 18 }}>
 <Btn onClick={() => { navigate('/contact'); setMenuOpen(false); }}>Free Check-in</Btn>
 </div>
 </div>
 )}
 </nav>
 );
}